export default __webpack_public_path__ + "static/media/two.9d2e45ff.jpg";